/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notifications_Footer_TotalInputs */

const en_notifications_footer_total = /** @type {(inputs: Notifications_Footer_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} notifications`)
};

const pt_br2_notifications_footer_total = /** @type {(inputs: Notifications_Footer_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} notificações`)
};

/**
* | output |
* | --- |
* | "{count} notifications" |
*
* @param {Notifications_Footer_TotalInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_footer_total = /** @type {((inputs: Notifications_Footer_TotalInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Footer_TotalInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_footer_total(inputs)
	return pt_br2_notifications_footer_total(inputs)
});